import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import {
  companyPhone,
  companyEmail,
  companyLegalAddress,
  companyBankAccount,
  companyBankInfo,
  companyRegistrationNumber,
  technicalSupportEmail,
  companyName,
} from "../config/globalVariables";
import Hero from "../components/UI/Hero";

const Contacts = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("seo.title.contacts")}</title>
        <meta name="description" content={t("seo.description.contacts")} />
        <meta property="og:title" content={t("seo.title.contacts")} />
        <meta
          property="og:description"
          content={t("seo.description.contacts")}
        />
      </Helmet>
      <Hero
        title={t("hero.contacts.title")}
        subtitle={t("hero.contacts.subtitle")}
      />
      <Container maxWidth="lg" sx={{ my: 5, mb: 7 }}>
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6}>
            <Paper sx={{ padding: 4, borderRadius: 3, mt: 3 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                <Typography
                  sx={{ mb: 1 }}
                  color="primary"
                  variant="h4"
                  gutterBottom
                  textAlign="left"
                >
                  {t("contact_page.contacts")}
                </Typography>
                <Box>
                  <Typography variant="body1">{companyEmail}</Typography>
                </Box>
                <Box>
                  <Typography variant="body1">{companyPhone}</Typography>
                </Box>

                {/* <Divider sx={{ my: 2 }} /> */}

                <Typography
                  sx={{ mb: 1, mt: 2 }}
                  color="primary"
                  variant="h4"
                  gutterBottom
                  textAlign="left"
                >
                  {t("contact_page.gdpr_support")}
                </Typography>
                <Box>
                  <Typography variant="body1">
                    {technicalSupportEmail}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper sx={{ padding: 4, borderRadius: 3, mt: 3 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                <Typography
                  sx={{ mb: 1 }}
                  color="primary"
                  variant="h4"
                  gutterBottom
                  textAlign="left"
                >
                  {t("contact_page.requisites")}
                </Typography>
                <Box>
                  <Typography variant="body1">{companyName}</Typography>
                </Box>
                <Box>
                  <Typography variant="body1">
                    {t("contact_page.registration_number") + " "}
                    {companyRegistrationNumber}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body1">
                    {t("contact_page.legal_address") + " "}
                    {companyLegalAddress}
                  </Typography>
                </Box>
                {/* <Divider sx={{ my: 2 }} /> */}
                <Box>
                  <Typography variant="body1">{companyBankInfo}</Typography>
                </Box>
                <Box>
                  <Typography variant="body1">{companyBankAccount}</Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Contacts;
